import React from "react";

import { ArrowLeft } from "iconsax-react";

import errorPageImage from "../../../image/errorPageImage.png";

import { StyledSection, ParrentError, StyledLink } from "./styledErrorPage";

const ErrorPage = () => {
  return (
    <StyledSection className="container text-center">
      <ParrentError>
        <img
          src={errorPageImage}
          alt="404 error"
          width="642"
          className="img-fluid"
        />
        <h2>صفحه‌ی مورد نظر یافت نشد!</h2>
        <StyledLink to="/">
          صفحه‌ی اصلی
          <ArrowLeft color="var(--tertiary-color)" className="me-3" />
        </StyledLink>
      </ParrentError>
    </StyledSection>
  );
};

export default ErrorPage;
